import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { MapPinIcon } from 'lucide-react';
const states = ['Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'];
const container = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.03
    }
  }
};
const item = {
  hidden: {
    opacity: 0,
    y: 12,
    scale: 0.95
  },
  show: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 0.3,
      ease: 'easeOut'
    }
  }
};
export function StatesList() {
  const handleRedirect = () => {
    window.location.href = 'https://trackrt.activapleno.com/click';
  };
  return <motion.div variants={container} initial="hidden" whileInView="show" viewport={{
    once: true,
    margin: '-40px'
  }} className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3" data-id="element-74">
      {states.map(state => <motion.button key={state} variants={item} onClick={handleRedirect} whileHover={{
      scale: 1.04,
      y: -2
    }} whileTap={{
      scale: 0.97
    }} className="group flex items-center gap-2 px-4 py-3 bg-white border border-gray-200 rounded-xl text-left text-[#111] font-medium text-sm hover:border-[#F5A623] hover:bg-amber-50 hover:shadow-md transition-colors cursor-pointer" data-id="element-75">
          <MapPinIcon className="w-4 h-4 text-gray-400 group-hover:text-[#F5A623] transition-colors flex-shrink-0" data-id="element-76" />
          <span className="truncate" data-id="element-77">{state}</span>
        </motion.button>)}
    </motion.div>;
}